import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { environment } from '../../environments/environment';

export interface ComplaintStatusModel {
  id?: number;
  description: string;
  createdAt?: string;  // LocalDateTime -> string no formato ISO (YYYY-MM-DDTHH:mm:ss)
  updatedAt?: string;  // LocalDateTime -> string ISO
  deletedAt?: string;  // LocalDateTime -> string ISO (para soft delete)
  // Note: 'complaints' não está incluído porque tem @JsonIgnore no Java
}

@Injectable({
  providedIn: 'root'
})
export class ComplaintStatusService {

  private readonly baseUrl = `${environment.apiUrl}/nucon/api/v1/complaint/status`;

  private readonly httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  };

  constructor(private http: HttpClient) {}

  findAll(): Observable<ComplaintStatusModel[]> {
    return this.http.get(`${this.baseUrl}/all`, { ...this.httpOptions, responseType: 'text' }).pipe(
      map(raw => {
        if (!raw || raw.trim() === '') return [];
        try {
          const parsed = JSON.parse(raw);
          return Array.isArray(parsed) ? parsed : (parsed?.content ?? parsed?.data ?? parsed?.items ?? []);
        } catch {
          console.warn('[ComplaintStatus] resposta não é JSON:', raw);
          return [];
        }
      })
    );
  }

  findById(id: number): Observable<ComplaintStatusModel> {
    return this.http.get<ComplaintStatusModel>(`${this.baseUrl}/${id}`, this.httpOptions);
  }

  save(complaintStatus: ComplaintStatusModel): Observable<ComplaintStatusModel> {
    return this.http.post<ComplaintStatusModel>(this.baseUrl, complaintStatus, this.httpOptions);
  }

  update(id: number, complaintStatus: ComplaintStatusModel): Observable<ComplaintStatusModel> {
    return this.http.put<ComplaintStatusModel>(`${this.baseUrl}/${id}`, complaintStatus, this.httpOptions);
  }

  softDeleteById(id: number): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/soft-delete/${id}`, this.httpOptions);
  }
}
